<script lang="ts">import Google from "./google.svelte";
import WalletConnect from "./wallet-connect.svelte";
import { stateUi } from "@infinitro/config";
</script>

<div class="section">
	<Google />
	{#if $stateUi.auth?.showWalletConnect === true}
		<WalletConnect />
	{/if}
</div>

<style>
	.section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem
}
</style>
